import { SET_ACCESS_LEVEL } from './action-modulation.type';

export const state = {
  accessLevel: null,
};

export const actions = {
  [SET_ACCESS_LEVEL](context, level) {
    return context.commit(SET_ACCESS_LEVEL, level);
  },
};

export const mutations = {
  [SET_ACCESS_LEVEL](state, level) {
    state.accessLevel = level;
  },
};

export default {
  state,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/access.module.js